import featureFlag from './feature-flag';

const directives = {
	'feature-flag': featureFlag
};

export const registerDirectives = (app) => {
	Object.keys(directives).forEach((key) => {
		app.directive(key, directives[key]);
	});
};
